/*
  biberna - Logik des Set-Konfigurators auf der Produktseite.
  Markup, CSS und Daten liefert snippets/biberna-pdp-bundle.liquid,
  die Zuordnungstabellen snippets/biberna-set-rules.liquid,
  das Varianten-Matching assets/biberna-set-match.js.

  RABATTMODELL
  Der hinterlegte Rabatt ist ein "Kaufe X, erhalte Y":
    kauft 1 aus Bettwaesche -> erhaelt 2 aus Spannbettlaken +
    Matratzenschutz zu 30 %, einmal pro Bestellung.

  Der Nachlass liegt also NUR auf dem Zubehoer, nicht auf der
  Bettwaesche. Genau so rechnet diese Datei. Ein pauschaler Prozentsatz
  auf die Gesamtsumme waere falsch - er faellt je nach Bettwaesche-Preis
  unterschiedlich aus (bei Mako-Satin rund 11 %, bei Castell Renforce
  rund 19 %).

  RUNDUNG - am 1.9.2026 gegen den echten Warenkorb geprueft.
  Shopify rundet JE POSITION und schneidet dabei ab:
    Schoner 23,95 x 30 % = 7,185 -> 7,18
    Laken   20,95 x 30 % = 6,285 -> 6,28   Summe 13,46
  Einmal auf die Zubehoersumme gerechnet kaeme 13,47 heraus - ein Cent
  zu viel. Deshalb wird pro Teil abgerundet und erst dann summiert.
  Abrunden ist auch die sichere Richtung: lieber einen Cent zu wenig
  ankuendigen als einen zu viel.

  Bewusst konservativ: Die Ersparnis wird erst ausgewiesen, wenn BEIDE
  Zubehoerteile dabei sind. Der Rabatt nennt "2 Artikel"; ob Shopify bei
  nur einem anteilig rabattiert, ist nicht zugesichert.

  12.09.2026 - RABATTCODE IM WARENKORB SCHLAEGT DEN SET-VORTEIL
  Der Set-Vorteil hat combinesWith.productDiscounts = false. Liegt ein
  Gutschein im Warenkorb, gewaehrt Shopify nur den fuer die Kundin
  guenstigeren - und das ist praktisch immer der Gutschein:
    Garnitur 49,95 + Laken 23,95 = 73,90
      Newsletter 25 % auf alles  -> 18,48
      Set-Vorteil 30 % auf Laken ->  7,18
  In den 125 Bestellungen seit dem 1.9. hat der Set-Vorteil deshalb
  KEIN EINZIGES Mal gegriffen; 60 % dieser Bestellungen trugen einen
  Newsletter-Einzelcode. Wir pruefen daher /cart.js und nennen den
  Prozentsatz nur, wenn kein Code im Korb liegt. Sonst verspricht die
  Seite etwas, das der Warenkorb nicht einloest.

  12.09.2026 - VORAUSWAHL AUS DER PDP-VARIANTE
  Bis hierher wurde immer values[0] vorgewaehlt, also meist "Weiss" in
  der kleinsten Groesse. Farbe und Groesse kommen jetzt aus der oben
  gewaehlten Bettwaesche. Zwei Regeln:
    - Groesse schlaegt Farbe. Eine falsche Farbe ist ein Kompromiss,
      eine falsche Groesse ist eine Retoure.
    - Hat die Kundin ein Dropdown selbst angefasst, wird ihre Wahl nie
      wieder ueberschrieben (touched-Flags).

  20.09.2026 - DER HINWEIS NENNT JETZT SEINEN ANKER
  matchHintText bekommt die Rolle des Seitenprodukts mit ("Bettwaesche",
  "Spannbettlaken", "Matratzenschoner"). Ohne sie stand auf einer
  Laken-Seite "Passend zu Weiss, 1x 180x200 cm - 200x200 cm" ueber dem
  Bettwaesche-Vorschlag - ein Matratzenmass ueber einem Artikel, den es
  in diesem Mass nicht gibt. Der Wert kommt aus dem Markup (erster
  Slot), nicht aus dem Datenblock: Er steht dort ohnehin sichtbar, und
  set-match.js bleibt so frei von DOM-Wissen.

  WARENKORB
  Das Theme benutzt Dawns cart-drawer. Ein blosses Nachladen des
  Zaehler-Bubbles genuegt dort NICHT - der Drawer behaelt seinen alten
  Inhalt, und die Artikel erscheinen erst nach einem Seitenwechsel.
  Deshalb werden die Sections mitangefordert, die Dawn selbst rendern
  wuerde, und anschliessend Dawns renderContents() aufgerufen.
*/
(function () {
  var root = document.querySelector('[data-bib-bundle]');
  if (!root) return;

  var data;
  try {
    data = JSON.parse(document.querySelector('[data-bib-bundle-data]').textContent);
  } catch (e) {
    if (window.console) console.warn('[biberna] Bundle-Daten nicht lesbar:', e);
    root.remove();
    return;
  }

  var rules = data.rules || { sizeMap: {}, colorFallback: {}, neutralDefault: [] };

  var euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  function money(cents) { return euro.format(cents / 100); }

  var el = {
    subtotal: root.querySelector('[data-bib-subtotal]'),
    sumLabel: root.querySelector('[data-bib-sum-label]'),
    saveRow: root.querySelector('[data-bib-save-row]'),
    save: root.querySelector('[data-bib-save]'),
    total: root.querySelector('[data-bib-total]'),
    note: root.querySelector('[data-bib-note]'),
    cta: root.querySelector('[data-bib-add]'),
    msg: root.querySelector('[data-bib-msg]'),
    beddingPrice: root.querySelector('[data-bib-price="bedding"]'),
    beddingVariant: root.querySelector('[data-bib-bedding-variant]'),
    sheetColor: root.querySelector('[data-bib-pick="sheet-color"]'),
    sheetSize: root.querySelector('[data-bib-pick="sheet-size"]'),
    guardSize: root.querySelector('[data-bib-pick="guard-size"]'),
    sheetPrice: root.querySelector('[data-bib-price="sheet"]'),
    guardPrice: root.querySelector('[data-bib-price="guard"]'),
    sheetToggle: root.querySelector('[data-bib-toggle="sheet"]'),
    guardToggle: root.querySelector('[data-bib-toggle="guard"]'),
    sheetSold: root.querySelector('[data-bib-soldout="sheet"]'),
    guardSold: root.querySelector('[data-bib-soldout="guard"]')
  };

  var missing = Object.keys(el).filter(function (k) { return !el[k]; });
  if (missing.length) {
    if (window.console) console.warn('[biberna] Bundle unvollstaendig:', missing);
    root.remove();
    return;
  }

  /* Slot 3 fuehrt seit 11.09.2026 optional Farben: Auf Matratzenschoner-
     Seiten steht dort ein Spannbettlaken, auf Bettwaesche- und Laken-Seiten
     der einfarbige Molton-Schoner. Der Select wird nur im ersten Fall
     gerendert - deshalb NICHT in die Vollstaendigkeitspruefung oben, sonst
     verschwaende das ganze Bundle auf allen anderen Seiten. */
  el.guardColor = root.querySelector('[data-bib-pick="guard-color"]');
  var guardHasColor = !!el.guardColor && data.guard.hasColor === true;

  /* Optional - fehlt in aelteren Snippet-Staenden, darf deshalb ebenfalls
     nicht in die Vollstaendigkeitspruefung. */
  el.matchHint = root.querySelector('[data-bib-match]');

  /* Rolle des Seitenprodukts fuer den Hinweistext - siehe Kopf (20.09.2026).
     Steht als sichtbare Zeile im ersten Slot ("BETTWAESCHE", "SPANNBETTLAKEN",
     "MATRATZENSCHONER"). Fehlt sie, bleibt ownLabel leer und der Hinweis
     lautet wie vorher - kein "undefined" auf der Seite. */
  var ownLabel = '';
  var ownRole = root.querySelector('[data-bib-slot="bedding"] .bib-item__role');
  if (ownRole && ownRole.textContent) ownLabel = ownRole.textContent.trim();

  /* Sobald die Kundin selbst waehlt, haelt der Konfigurator die Finger
     still. Ohne diese Flags springt ihre Wahl beim naechsten Klick auf
     einen Farbswatch der Bettwaesche wieder zurueck. */
  var touched = { sheetColor: false, sheetSize: false, guardColor: false, guardSize: false };

  /* Wird nach dem /cart.js-Abruf gesetzt. Bis dahin bewusst true: Wir
     behaupten die 30 % lieber eine Sekunde zu spaet als zu Unrecht. */
  var cartBlocksDiscount = true;

  function uniq(list) {
    var seen = {}, out = [];
    list.forEach(function (x) { if (x && !seen[x]) { seen[x] = 1; out.push(x); } });
    return out;
  }

  function fill(select, values, keep) {
    var before = keep && values.indexOf(keep) !== -1 ? keep : values[0];
    select.innerHTML = '';
    values.forEach(function (v) {
      var o = document.createElement('option');
      o.value = v;
      o.textContent = v;
      select.appendChild(o);
    });
    select.value = before;
  }

  function optionValues(select) {
    return Array.prototype.map.call(select.options, function (o) { return o.value; });
  }

  /* Nur lieferbare Varianten anbieten - eine Farbe, die es in keiner
     Groesse mehr gibt, taucht gar nicht erst auf. */
  var sheetLive = data.sheet.variants.filter(function (v) { return v.available; });
  var guardLive = data.guard.variants.filter(function (v) { return v.available; });

  /* Matching und Hinweistext liegen in assets/biberna-set-match.js -
     reine Logik, dort auch getestet (test-derive.cjs). Fehlt die Datei,
     laeuft der Konfigurator ohne Vorauswahl weiter, statt eine falsche
     Variante vorzuschlagen. */
  var matcher = window.bibernaSetMatch || null;
  if (!matcher && window.console) console.warn('[biberna] set-match fehlt - keine Vorauswahl');

  function deriveSelection(bedding, live, withColor) {
    if (!matcher) return null;
    return matcher.deriveSelection(bedding, live, withColor, rules);
  }

  function sheetPick() {
    var c = el.sheetColor.value, s = el.sheetSize.value;
    for (var i = 0; i < sheetLive.length; i++) {
      if (sheetLive[i].color === c && sheetLive[i].size === s) return sheetLive[i];
    }
    return null;
  }

  function guardPick() {
    var s = el.guardSize.value;
    var c = guardHasColor ? el.guardColor.value : null;
    for (var i = 0; i < guardLive.length; i++) {
      if (guardLive[i].size !== s) continue;
      if (guardHasColor && guardLive[i].color !== c) continue;
      return guardLive[i];
    }
    return null;
  }

  function beddingPick() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var input = form && form.querySelector('[name="id"]');
    if (!input) return null;
    var v = data.bedding[String(input.value)];
    if (!v) return null;
    return {
      id: String(input.value),
      price: v.price,
      title: v.title,
      available: v.available,
      color: v.color,
      size: v.size
    };
  }

  function refreshSheetSizes(prefer) {
    var color = el.sheetColor.value;
    var sizes = uniq(sheetLive.filter(function (v) { return v.color === color; }).map(function (v) { return v.size; }));
    fill(el.sheetSize, sizes, prefer || el.sheetSize.value);
  }

  /* Gegenstueck fuer Slot 3, sobald dort Farben gefuehrt werden. */
  function refreshGuardSizes(prefer) {
    if (!guardHasColor) return;
    var color = el.guardColor.value;
    var sizes = uniq(guardLive.filter(function (v) { return v.color === color; }).map(function (v) { return v.size; }));
    fill(el.guardSize, sizes, prefer || el.guardSize.value);
  }

  /* Setzt die abgeleitete Auswahl - aber nur dort, wo die Kundin noch
     nicht selbst entschieden hat. */
  function applyDerived(bedding) {
    var s = deriveSelection(bedding, sheetLive, true);
    if (s) {
      if (!touched.sheetColor) {
        el.sheetColor.value = s.color;
        refreshSheetSizes(touched.sheetSize ? null : s.size);
      }
      if (!touched.sheetSize && optionValues(el.sheetSize).indexOf(s.size) !== -1) {
        el.sheetSize.value = s.size;
      }
    }

    var g = deriveSelection(bedding, guardLive, guardHasColor);
    if (g) {
      if (guardHasColor && !touched.guardColor) {
        el.guardColor.value = g.color;
        refreshGuardSizes(touched.guardSize ? null : g.size);
      }
      if (!touched.guardSize && optionValues(el.guardSize).indexOf(g.size) !== -1) {
        el.guardSize.value = g.size;
      }
    }

    /* Slot abschalten statt falsch vorbelegen. */
    setSlotUnavailable('sheet', el.sheetToggle, !s && !!bedding);
    setSlotUnavailable('guard', el.guardToggle, !g && !!bedding);

    showMatchHint(bedding, s);
  }

  function setSlotUnavailable(name, toggle, off) {
    var sold = name === 'sheet' ? el.sheetSold : el.guardSold;
    toggle.disabled = off;
    if (off) {
      toggle.checked = false;
      sold.textContent = 'Für diese Größe haben wir hier gerade nichts Passendes.';
    }
  }

  function showMatchHint(bedding, s) {
    if (!el.matchHint) return;

    var text = (matcher && !touched.sheetColor && !touched.sheetSize)
      ? matcher.matchHintText(bedding, s, ownLabel)
      : '';

    el.matchHint.textContent = text;
    el.matchHint.hidden = !text;
  }

  function cartHost() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function cartSectionIds() {
    var host = cartHost();
    if (!host || typeof host.getSectionsToRender !== 'function') return null;
    try {
      return host.getSectionsToRender().map(function (s) { return s.id; });
    } catch (e) {
      return null;
    }
  }

  /* Rueckfallebene, falls Dawn sich anders verhaelt als erwartet. */
  function refreshCartCount() {
    fetch('/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var html = s['cart-icon-bubble'];
        if (!html) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#cart-icon-bubble');
        var live = document.querySelector('#cart-icon-bubble');
        if (fresh && live) live.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* Zaehler bleibt stehen */ });
  }

  /* Liegt ein Gutschein im Korb, verdraengt er den Set-Vorteil. Siehe Kopf. */
  function checkCartDiscounts() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = cart.discount_codes || [];
        cartBlocksDiscount = codes.some(function (c) { return c.applicable !== false; });
      })
      .catch(function () {
        /* Kein Abruf moeglich - dann lieber nicht mit Prozenten werben. */
        cartBlocksDiscount = true;
      });
  }

  function render() {
    var bedding = beddingPick();
    var sheet = el.sheetToggle.checked ? sheetPick() : null;
    var guard = el.guardToggle.checked ? guardPick() : null;

    root.querySelector('[data-bib-slot="sheet"]').classList.toggle('bib-item--off', !el.sheetToggle.checked);
    root.querySelector('[data-bib-slot="guard"]').classList.toggle('bib-item--off', !el.guardToggle.checked);

    el.beddingPrice.textContent = bedding ? money(bedding.price) : '–';
    el.beddingVariant.textContent = bedding
      ? bedding.title + (bedding.available ? '' : ' – derzeit nicht lieferbar')
      : 'Bitte oben eine Variante wählen';

    el.sheetPrice.textContent = sheet ? money(sheet.price) : '–';
    el.guardPrice.textContent = guard ? money(guard.price) : '–';

    if (!el.sheetToggle.disabled) {
      el.sheetSold.textContent = el.sheetToggle.checked && !sheet ? 'Diese Kombination ist vergriffen.' : '';
    }
    if (!el.guardToggle.disabled) {
      el.guardSold.textContent = el.guardToggle.checked && !guard ? 'Diese Größe ist vergriffen.' : '';
    }

    var beddingOk = !!(bedding && bedding.available);

    var accessories = [];
    if (sheet) accessories.push(sheet);
    if (guard) accessories.push(guard);

    var parts = [];
    if (beddingOk) parts.push(bedding);
    parts = parts.concat(accessories);

    var subtotal = parts.reduce(function (a, p) { return a + p.price; }, 0);

    /* Bedingung des hinterlegten Rabatts: Bettwaesche im Korb UND beide
       Zubehoerteile. Ohne aktiven Rabatt - oder mit Gutschein im Korb -
       wird nichts behauptet. */
    var qualifies = data.active && !cartBlocksDiscount && beddingOk && accessories.length >= data.minAcc;

    /* Je Position abrunden - so rechnet Shopify auch, siehe Kopf. */
    var save = 0;
    if (qualifies) {
      save = accessories.reduce(function (a, p) {
        return a + Math.floor(p.price * data.pct / 100);
      }, 0);
    }

    el.sumLabel.textContent = qualifies ? 'Einzeln gekauft' : 'Summe';
    el.subtotal.textContent = subtotal ? money(subtotal) : '–';
    el.saveRow.hidden = !qualifies;
    el.save.textContent = '− ' + money(save);
    el.total.textContent = subtotal ? money(subtotal - save) : '–';

    if (!beddingOk) {
      el.note.textContent = 'Die gewählte Bettwäsche-Variante ist nicht lieferbar.';
    } else if (!data.active) {
      el.note.textContent = 'Alle Teile mit einem Klick im Warenkorb – Rabatte werden dort verrechnet.';
    } else if (cartBlocksDiscount) {
      el.note.textContent = 'Du hast bereits einen Gutschein im Warenkorb – im Warenkorb rechnen wir automatisch den für dich günstigeren Vorteil.';
    } else if (qualifies) {
      el.note.textContent = 'Die ' + data.pct + ' % auf Laken und Schoner werden im Warenkorb abgezogen.';
    } else {
      el.note.textContent = 'Mit Laken und Schoner zusammen gibt es ' + data.pct + ' % auf beide.';
    }

    el.cta.disabled = !beddingOk;
    el.cta.textContent = parts.length > 1
      ? 'Alle ' + parts.length + ' Teile in den Warenkorb'
      : 'In den Warenkorb';

    root.bibParts = parts;
  }

  function add() {
    var parts = root.bibParts || [];
    if (!parts.length) return;

    el.cta.disabled = true;
    el.cta.textContent = 'Moment …';
    el.msg.textContent = '';

    var payload = {
      items: parts.map(function (p) { return { id: Number(p.id), quantity: 1 }; })
    };

    var ids = cartSectionIds();
    if (ids && ids.length) {
      payload.sections = ids;
      payload.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body.description || body.message || 'Unbekannter Fehler');
          return body;
        });
      })
      .then(function (body) {
        var host = cartHost();
        var drawn = false;

        if (host && body.sections && typeof host.renderContents === 'function') {
          try {
            host.renderContents(body);
            drawn = true;
          } catch (e) {
            if (window.console) console.warn('[biberna] Drawer-Render fehlgeschlagen:', e);
          }
        }

        if (!drawn) refreshCartCount();
        el.msg.textContent = drawn ? '' : 'Liegt im Warenkorb.';
      })
      .catch(function (err) {
        if (window.console) console.warn('[biberna] Bundle nicht hinzugefuegt:', err);
        el.msg.textContent = 'Das hat nicht geklappt: ' + err.message;
      })
      .then(function () {
        return checkCartDiscounts();
      })
      .then(function () {
        render();
      });
  }

  function onBeddingChanged() {
    applyDerived(beddingPick());
    render();
  }

  /* Dawn meldet den Variantenwechsel selbst - vorher wurde hier blind
     nach 150/500/1000 ms nachgefasst. Das Abo greift deterministisch;
     die Timer bleiben nur als Rueckfallebene, falls pubsub fehlt. */
  function watchVariantChange() {
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, onBeddingChanged);
      return;
    }
    document.addEventListener('change', function (e) {
      if (!(e.target.closest && e.target.closest('variant-selects'))) return;
      [150, 500, 1000].forEach(function (d) { setTimeout(onBeddingChanged, d); });
    });
  }

  function init() {
    if (!sheetLive.length || !guardLive.length) { root.remove(); return; }

    fill(el.sheetColor, uniq(sheetLive.map(function (v) { return v.color; })));
    refreshSheetSizes();

    if (guardHasColor) {
      fill(el.guardColor, uniq(guardLive.map(function (v) { return v.color; })));
      refreshGuardSizes();
      el.guardColor.addEventListener('change', function () {
        touched.guardColor = true;
        refreshGuardSizes();
        render();
      });
    } else {
      fill(el.guardSize, uniq(guardLive.map(function (v) { return v.size; })));
    }

    el.sheetColor.addEventListener('change', function () {
      touched.sheetColor = true;
      refreshSheetSizes();
      showMatchHint(beddingPick(), null);
      render();
    });
    el.sheetSize.addEventListener('change', function () { touched.sheetSize = true; render(); });
    el.guardSize.addEventListener('change', function () { touched.guardSize = true; render(); });
    el.sheetToggle.addEventListener('change', render);
    el.guardToggle.addEventListener('change', render);
    el.cta.addEventListener('click', add);

    watchVariantChange();

    applyDerived(beddingPick());
    render();

    checkCartDiscounts().then(render);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
